import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import flatpickr from 'flatpickr';
import { Instance } from 'flatpickr/dist/types/instance';

@Directive({
	selector: '[appDatepicker]'
})
export class DatepickerDirective implements AfterViewInit, OnDestroy {
	@Input() formControl!: AbstractControl | null;
	private flatpickrInstance?: Instance;

	constructor(private el: ElementRef) {}

	ngAfterViewInit(): void {
		this.flatpickrInstance = flatpickr(this.el.nativeElement, {
			dateFormat: 'Y-m-d', // formato del valore nel FormControl (per il DB)
			altInput: true, // mostra un input alternativo all'utente
			altFormat: 'd/m/Y', // formato italiano visualizzato: 31/12/2025
			onChange: selectedDates => {
				if (this.formControl) {
					if (selectedDates.length) {
						const date = selectedDates[0];
						// Formato per il DB: YYYY-MM-DD
						const isoLocal =
							date.getFullYear() +
							'-' +
							String(date.getMonth() + 1).padStart(2, '0') +
							'-' +
							String(date.getDate()).padStart(2, '0');
						this.formControl.setValue(isoLocal);
					} else {
						this.formControl.setValue(null);
					}
				}
			}
		});

		// Imposta la data iniziale se presente nel FormControl
		if (this.formControl?.value) {
			this.setInitialDate(this.formControl.value);
		}

		// Ascolta i cambiamenti del FormControl per aggiornare flatpickr
		this.formControl?.valueChanges.subscribe(value => {
			if (value && this.flatpickrInstance) {
				this.setInitialDate(value);
			}
		});
	}

	private setInitialDate(value: string): void {
		if (!value || !this.flatpickrInstance) return;

		try {
			// Gestisce il formato YYYY-MM-DD
			const parts = value.split('-');
			if (parts.length === 3) {
				const year = parseInt(parts[0], 10);
				const month = parseInt(parts[1], 10) - 1; // mesi 0-indexed in JS
				const day = parseInt(parts[2], 10);
				const dateObj = new Date(year, month, day);
				
				// Verifica che la data sia valida
				if (!isNaN(dateObj.getTime())) {
					this.flatpickrInstance.setDate(dateObj, false); // false per non triggerare onChange
				}
			}
		} catch (error) {
			console.error('Errore nel parsing della data:', error);
		}
	}

	ngOnDestroy(): void {
		// Pulisce l'istanza flatpickr quando il componente viene distrutto
		if (this.flatpickrInstance) {
			this.flatpickrInstance.destroy();
		}
	}
}